import React, { Fragment } from 'react';
import { pushHistory, getBreadcrumbPaths } from 'utils';

export default ({ history }) => {
  const routes = getBreadcrumbPaths();
  const gotoRoute = ({ path, breadcrumbRegex = false }) => {
    if (breadcrumbRegex) {
      const { pathname } = window.location;
      const [, id] = pathname.match(breadcrumbRegex);
      return pushHistory({ history, path: path.replace(':id', id) });
    }
    return pushHistory({ history, path });
  };

  if (!routes || !Array.isArray(routes) || !routes.length) {
    return <></>;
  }

  return (
    <div className="breadcrumb">
      {routes.map(({
        name, isCurrent, route, onClick,
      }, i) => (
        <Fragment key={i}>
          <span
            onClick={() => (onClick ? onClick(history) : isCurrent ? null : gotoRoute(route))}
            className={isCurrent ? 'breadcrumb-current' : 'breadcrumb-link'}
          >
            {name}
          </span>
          {!isCurrent && <span className="breadcrumb-divider"> / </span>}
        </Fragment>
      ))}
    </div>
  );
};
